import {RelationshipInterface} from "../Interfaces/RelationshipInterface";
import {BusinessObjectBaseInterface} from "../Interfaces/BusinessObjectBaseInterface";

export class Relationship implements RelationshipInterface {
    readonly id: number;
    private _name: string;
    private _inward: string;
    private _outward: string;
    private _systemRequired: boolean;
    private _fromBoClass: BusinessObjectBaseInterface;
    private _toBoClass: BusinessObjectBaseInterface;

    constructor(id: number, name: string, inward: string, outward: string, fromBoClass: BusinessObjectBaseInterface, toBoClass: BusinessObjectBaseInterface, systemRequired: boolean) {
        this.id = id;
        this.name = name;
        this.inward = inward;
        this.outward = outward;
        this.fromBoClass = fromBoClass;
        this.toBoClass = toBoClass;
        this.systemRequired = systemRequired;
    }

    get name(): string {
        return this._name;
    }

    set name(value: string) {
        this._name = value;
    }

    get inward(): string {
        return this._inward;
    }

    get systemRequired(): boolean {
        return this._systemRequired;
    }

    set systemRequired(value: boolean) {
        this._systemRequired = value;
    }

    set inward(value: string) {
        this._inward = value;
    }

    get outward(): string {
        return this._outward;
    }

    set outward(value: string) {
        this._outward = value;
    }

    get fromBoClass(): BusinessObjectBaseInterface {
        return this._fromBoClass;
    }

    set fromBoClass(value: BusinessObjectBaseInterface) {
        this._fromBoClass = value;
    }

    get toBoClass(): BusinessObjectBaseInterface {
        return this._toBoClass;
    }

    set toBoClass(value: BusinessObjectBaseInterface) {
        this._toBoClass = value;
    }

    clone(): Relationship {
        return new Relationship(this.id, this.name, this.inward, this.outward, this.fromBoClass, this.toBoClass, this.systemRequired);
    }

    isErasable(): { erasable: boolean; msg: string | null } {
        if (this.systemRequired) {
            return {erasable: false, msg: "You cannot delete this relationship, because it is set as system relationship."};
        }
        return {erasable: true, msg: null};
    }


    equal(relationship: Relationship): boolean {
        if (!relationship) {
            return false;
        }
        if (this.name.trim() !== relationship.name.trim()) {
            return false
        }
        if (this.inward.trim() !== relationship.inward.trim()) {
            return false
        }
        if (this.outward.trim() !== relationship.outward.trim()) {
            return false
        }
        if (this.fromBoClass.id !== relationship.fromBoClass.id) {
            return false
        }
        if (this.systemRequired !== relationship.systemRequired) {
            return false;
        }
        return this.toBoClass.id === relationship.toBoClass.id;
    }

    isValid(): { valid: boolean, data: Map<string, { valid: boolean, msg: string }> } {
        const data = new Map([
            ["name", {
                valid: this.name.trim() !== "",
                msg: this.name.trim() === "" ? "Relationship name can't be an empty string." : null
            }],
            ["inward", {
                valid: this.inward.trim() !== "",
                msg: this.inward.trim() === "" ? "Relationship inward can't be an empty string." : null
            }],
            ["outward", {
                valid: this.outward.trim() !== "",
                msg: this.outward.trim() === "" ? "Relationship outward can't be an empty string." : null
            }],
            ["fromBoClass", {
                valid: !(this.fromBoClass.id === -1),
                msg: (this.fromBoClass.id === -1) ? '"Relationship from Type" is not selected.' : null
            }],
            ["toBoClass", {
                valid: !(this.toBoClass.id === -1),
                msg: (this.toBoClass.id === -1) ? '"Relationship to Type" is not selected.' : null
            }]
        ]);
        return {valid: !Array.from(data.values()).some(item => item.valid === false), data}
    }

    setPrototype(name: string, value: any): void {
        this[name] = value
    }
}



// WEBPACK FOOTER //
// ./app/components/bo-core/models/Relationship.ts